import { useCallback } from "react";
import { toast } from "react-hot-toast";
import { useSessaoAtual } from "../../../services/providers/sessao-atual-provider/sessao-atual-provider";
import { useHistory } from "react-router";
import { useFormik } from "formik";
import './autoComLogin.css';
import Logo from '../../components/public/login/icon-login.svg';
import Ellipse1 from '../../components/public/login/ellipse13534366-h1ms.svg';
import Ellipse2 from '../../components/public/login/ellipse13534367-x809.svg'
import { CircularLoading } from "../../components/utils/circular-loading";
import { Helmet } from "react-helmet";
import { BaixasStorageKeys, useBaixasStorage } from "../../../services/use-cases/baixas-storage";
import { stringNumeros } from "../../../utils/string-numeros";
import { maskPhone } from "../../../utils/masks";
import { Button } from "@material-ui/core";

export const LoginPage = () => {
    const { Login, IrParaRota, carregando } = useSessaoAtual();
    const { setRegister, delRegister } = useBaixasStorage()
    const history = useHistory();
    delRegister(BaixasStorageKeys.emailTelefone, false)

    const formik = useFormik({
        initialValues: {
            email: '',
            telefone: ''
        },
        onSubmit: values => {
            EfetuarLogin(values.email, stringNumeros(values.telefone))
        }
    })

    const EfetuarLogin = useCallback(async (email: string, telefone: string) => {
        try {
            await Login(email, telefone)
            history.push(IrParaRota())
        } catch (e: any) {
            toast.error('Acesso não encontrado, cadastre-se para ver nosso conteúdo!')
            const emailTelefone = {
                email: formik.values.email,
                telefone: formik.values.telefone
            }
            setRegister(BaixasStorageKeys.emailTelefone, emailTelefone, false)
            history.push('/cadastrar')
        }
    }, [IrParaRota, Login, formik.values.email, formik.values.telefone, history, setRegister])

    return (
        <div className="loginPage">
            <Helmet>
                <title>Login - Saurus AutoCom</title>
            </Helmet>
            <div className="p-d-v1430-container">
                <div className="p-d-v1430-p-d-v1430">
                    <div className="p-d-v1430-group11911453">
                        <img alt="Ellipse11455" src={Ellipse1} className="p-d-v1430-svg09" />
                        <img alt="Ellipse11454" src={Ellipse2} className="p-d-v1430-svg10" />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="content-login">
                    <img alt="Ellipse11454" src={Logo} />
                </div>
                {carregando && <CircularLoading tipo="FULLSIZED" />}
                <div className="d-flex justify-content-center" style={{ flex: '1 1 100%' }}>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="content-acessar">
                            <div className="login-page">
                                <div className="mb-3">
                                    <span className="p-d-v1430-text03">Login</span>
                                </div>
                                <div className="mb-2">
                                    <span className="form-label">Email</span>
                                    <input type="email" className="form-control mt-1"
                                        {...formik.getFieldProps('email')} required={formik.values.telefone.length !== 0 ? false : true} autoComplete="new-password" inputMode="email" placeholder="@exemplo.com" />
                                </div>
                                <div className="justify-content-center d-flex ou-login">
                                    <hr className="hr-login" />
                                    OU
                                    <hr className="hr-login" />
                                </div>
                                <div className="mb-2">
                                    <span className="form-label">Telefone</span>
                                    <input type="phone" className="form-control mt-1"
                                        {...formik.getFieldProps('telefone')} onChange={e => formik.setFieldValue('telefone', maskPhone(e.target.value))} required={formik.values.email.length !== 0 ? false : true} autoComplete="off" inputMode="numeric" placeholder="Insira seu número" />
                                </div>
                            </div>
                            <div className="d-grid gap-2 mt-4 mb-3 container-btn-acessar">
                                <Button className="btn btn-acessar mb-3" disabled={carregando} type="submit">Acessar</Button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}